import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

const COMPLETED_REQUEST_STATUSES = new Set([
  'completed',
  'delivered',
  'closed',
  'fulfilled',
]);

const ACTIVE_REQUEST_STATUSES = new Set([
  'pending',
  'accepted',
  'in-progress',
  'in_progress',
  'processing',
  'delivered',
]);

const normalize = value => value?.toString().toLowerCase().trim();

export function useTripRequestMeta(user) {
  const [meta, setMeta] = useState({
    completedTrips: {},
    acceptedCounts: {},
    userActiveRequests: {},
  });

  useEffect(() => {
    const requestsRef = collection(db, 'requests');

    const unsubscribe = onSnapshot(
      requestsRef,
      snapshot => {
        const completedTrips = {};
        const acceptedCounts = {};
        const userActiveRequests = {};

        snapshot.forEach(doc => {
          const data = doc.data();
          const tripId = data.tripId;
          if (!tripId) {
            return;
          }

          const status = normalize(data.status);

          if (status && COMPLETED_REQUEST_STATUSES.has(status)) {
            completedTrips[tripId] = true;
          }

          if (status === 'accepted') {
            acceptedCounts[tripId] = (acceptedCounts[tripId] || 0) + 1;
          }

          if (
            user &&
            (data.requesterId === user.uid ||
              data.tripOwnerId === user.uid ||
              normalize(data.requesterEmail) === normalize(user.email) ||
              normalize(data.tripOwnerEmail) === normalize(user.email))
          ) {
            if (status && ACTIVE_REQUEST_STATUSES.has(status)) {
              userActiveRequests[tripId] = true;
            }
          }
        });

        setMeta({ completedTrips, acceptedCounts, userActiveRequests });
      },
      error => {
        console.error('Requests listener error:', error);
      },
    );

    return () => unsubscribe();
  }, [user?.uid, user?.email]);

  return meta;
}


